export class Media {
    public url: string;
    public altText: string;
    public title: string;
    public id: number;
    public originalUrl: string;

    public static createMediaNotFound(): Media {
        const notFound: Media = new Media();
        notFound.url = 'assets/images/img-not-available.png';
        notFound.title = 'Image not found';
        notFound.altText = 'Image not found';
        return notFound;
    }
}
